import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  BASE_URL_OLD,
  FETCH_MAINTENANCE_LIST,
  MAINTENANCE_ALL,
  MAINTENANCE_PARTNER,
  M_GET,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';
import { ISwitchGames, IMaintenanceAll } from '@/interface/Mainternance';

@Module({ name: 'maintenance' })
export default class Maintenance extends VuexModule {
  @Action
  FetchGameStatus() {
    return Vue.axios({
      url: BASE_URL + FETCH_MAINTENANCE_LIST,
      method: M_GET,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action
  SwitchGameStatus(params: ISwitchGames) {
    return Vue.axios({
      url: BASE_URL_OLD + MAINTENANCE_PARTNER,
      method: M_POST,
      data: params,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action
  MaintenanceAll(params: IMaintenanceAll) {
    return Vue.axios({
      url: BASE_URL_OLD + MAINTENANCE_ALL,
      method: M_POST,
      data: params,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }
}
